<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <br>
      <h1 class="header-style">
        Emergency
        Contacts
      </h1>
      <p class="subheader-style">
        Please add your emergency contacts details here.
      </p><br>

      <v-btn
        fab
        color="#FFF"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <div v-if="isEmergencyContactsAvailable">
        <div
          v-for="(item, index) in userDetails.emergency_contact"
          :key="index"
        >
          <v-card
            light
            elevation="0"
            class="mb-3"
          >
            <v-card-text>
              <div class="btn-container">
                <div class="btns">
                  <v-btn
                    dark
                    fab
                    outlined
                    icon
                    color="#37474F"
                    x-small
                    @click="editEmgContact(index)"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn
                    dark
                    fab
                    outlined
                    icon
                    color="#37474F"
                    x-small
                    @click="deleteEmgContact(index)"
                  >
                    <v-icon small>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </div>
                <p class="title-text-style">
                  Name:
                  <font class="value-text-style">
                    {{ item.name }}
                  </font>
                </p>
              </div>
              <p class="title-text-style">
                Phone Number:
                <font class="value-text-style">
                  {{ item.phone_number }}
                </font>
              </p>
              <p class="title-text-style">
                Relation:
                <font class="value-text-style">
                  {{ item.relation }}
                </font>
              </p>
            </v-card-text>
          </v-card>
        </div>
      </div>
      <div
        v-else
        class="empty-alert-div"
      >
        <v-card
          color="#FFF"
          elevation="0"
        >
          <br>
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>
            No Contacts found
          </p>
          <br>
          <br>
        </v-card>
      </div>
      <div v-if="showEmergencyContact">
        <br>
        <v-card
          color="#FFF"
          elevation="0"
        >
          <v-card-title>
            <p class="process-header">
              Add Contact
            </p>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-text-field
                v-model="name"
                label="Enter Name*"
                dense
                :rules="[(v) => !!v || 'This field is required']"
                color="#000000"
                light
                outlined
              />
              <v-text-field
                v-model="phoneNumber"
                type="number"
                label="Enter Number*"
                dense
                :rules="phoneNumberRules"
                color="#000000"
                light
                outlined
              />
              <v-text-field
                v-model="relation"
                label="Enter Your Relation*"
                dense
                :rules="[(v) => !!v || 'This field is required']"
                color="#000000"
                light
                outlined
              />
            </v-form>
          </v-card-text>
        </v-card>
      </div>
      <br>
      <v-btn
        v-if="showEmergencyContact === false"
        class="btn-style"
        color="#64CA7F"
        elevation="0"
        @click="showEmergencyContactDialog"
      >
        <v-icon>mdi-plus</v-icon> Emergency Contact
      </v-btn>
      <div v-else>
        <v-btn
          class="btn-style"
          color="#000"
          elevation="0"
          @click="addEmergencyContact"
        >
          Add
        </v-btn>
        <v-btn
          class="btn-style grey-button"
          color="#E2E2E2"
          elevation="0"
          @click="showEmergencyContact = false"
        >
          Cancel
        </v-btn>
      </div>
      <center-spinner :loading="loading" />
    </div>
    <edit-emergency-contact
      v-if="showEdit"
      :edit-data="editData"
      :selected-index="selectedIndex"
      @closed="showEdit = false"
    />
    <alert-dialog
      v-if="showAlert"
      :title="'Confirm Delete'"
      :message="'Are you sure you want to delete the contact ?'"
      @closed="showAlert = false"
      @confirmed="deleteConfirmed()"
    />
  </v-dialog>
</template>

<script>
import spinner from '../../../components/SpinnerCentre.vue';
import Constants from 'src/constants';
import EditEmergencyContact from './EditEmergencyContact.vue';
import AlertDialog from '../../../components/AlertDialog.vue';

export default {
  name: 'EmergencyContacts',
  components: {
    'center-spinner': spinner,
    'edit-emergency-contact': EditEmergencyContact,
    'alert-dialog': AlertDialog,
  },
  data: () => ({
    loading: false,
    showModal: true,
    showAlert: false,
    showEmergencyContact: false,
    valid: false,
    name: '',
    phoneNumber: '',
    relation: '',
    emergencyContacts: [],
    showEdit: false,
    editData: null,
    selectedIndex: null,
  }),
  computed: {
    userDetails () {
      return this.$store.getters['userprofile/getUserDetails'];
    },
    isEmergencyContactsAvailable () {
      if (this.userDetails.emergency_contact.length !== 0) {
        return true;
      }
      return false;
    },
    phoneNumberRules () {
      return [
        (v) => !!v || 'This field is required',
        (v) => (v && v.length <= 15) || 'Phone number exceeded the limit.',
      ];
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    this.loading = true;
    await this.fetchUserDetails();
    this.loading = false;
  },
  methods: {
    async fetchUserDetails () {
      await this.$store.dispatch('userprofile/fetchUserDetails').then(() => {
        this.emergencyContacts = this.userDetails.emergency_contact;
      });
    },
    showEmergencyContactDialog () {
      if (this.userDetails.emergency_contact.length === 2) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'The user is limited to adding two contact details.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.showEmergencyContact = true;
    },
    async addEmergencyContact () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.loading = true;
      const data = {
        name: this.name,
        phone_number: this.phoneNumber,
        relation: this.relation,
      };
      this.emergencyContacts.push(data);
      this.$store
        .dispatch('userprofile/updateUserDetails', {
          details: {
            first_name: this.userDetails.first_name,
            last_name: this.userDetails.last_name,
            emergency_contact: this.emergencyContacts,
          },
        })
        .then((response) => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Emergency contact added successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.name = '';
          this.phoneNumber = '';
          this.relation = '';
          this.loading = false;
          this.showEmergencyContact = false;
          this.fetchUserDetails();
        })
        .catch((errors) => {
          this.loading = false;
        });
    },
    editEmgContact (index) {
      this.showEdit = true;
      this.editData = this.userDetails;
      this.selectedIndex = index;
    },
    deleteEmgContact (index) {
      this.selectedIndex = index;
      this.showAlert = true;
    },
    deleteConfirmed () {
      this.loading = true;
      this.showAlert = false;
      this.emergencyContactData = this.userDetails.emergency_contact;
      this.emergencyContactData.splice(this.selectedIndex, 1);
      this.$store
        .dispatch('userprofile/updateUserDetails', {
          details: {
            first_name: this.userDetails.first_name,
            last_name: this.userDetails.last_name,
            emergency_contact: this.emergencyContactData,
          },
        })
        .then(() => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Emergency contact deleted successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
        })
        .catch((errors) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.content-section {
  height: 100vh !important;
  overflow-x: scroll;
}

.btn-container {
  position: relative;
}

.btns {
  position: absolute;
  top: 0;
  right: 0;
  gap: 10px;
  display: flex;
}
</style>
